<div class="container">
    <div class="space-left"></div>
    <div class="toolbar">
        <button *ngFor="let product of products" 
            class="font-byzantine">
            {{product.name}}
        </button>
    </div>
    <div class="space-right"></div>
</div>